<script>
  import {VueMaskDirective as mask} from 'v-mask'

  export default {
    nome: 'leilao',
    directives: {mask},
    data () {
      return {
        isLoading: false
      }
    },
    computed: {},
    mounted () {
    },
    activated () {
    },
    destroyed () {
//      console.log('destruido')
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      }
    }
  }
</script>

<template>
    <div>
        <div class="etapa-arrematantes" style="display: none;">
            <div class="wrapper-md">
                <div class="panel panel-default">
                    <div class="panel-heading font-bold">Editar Arrematante</div>
                    <div class="panel-body">
                        <div class="panel-heading font-bold">Dados Pessoais</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">           
                                        <div class="col-md-12 m-b-md">
                                            <label for="" class="control-label">Nome</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-3">
                                            <label for="" class="control-label">Cpf</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Rg</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Orgão Emissor</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Data de Nascimento</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Apelido</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Nacionalidade</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Estado Civil</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Sexo</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="panel-body">
                        <div class="panel-heading font-bold">Dados necessários para aquisição de Imóveis (se casado)</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">  
                                        <div class="col-md-6">
                                            <label for="" class="control-label">Nome Conjuge</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Rg Conjuge</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Cpf Conjuge</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="panel-body">
                        <div class="panel-heading font-bold">Informações de Endereço</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">  
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Cep</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-6">
                                            <label for="" class="control-label">Endereco</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Número</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Complemento</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Bairro</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Cidade</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">UF</label>
                                            <select id="sel1" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                            </select>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="panel-body">
                        <div class="panel-heading font-bold">Informações de Contato</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">  
                                        <div class="col-md-6">
                                            <label for="" class="control-label">Email</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2">
                                            <label for="" class="control-label">Celular</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2">
                                            <label for="" class="control-label">Telefone</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2">
                                            <label for="" class="control-label">Telefone Comercial</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="panel-body">
                        <div class="panel-heading font-bold">Análise do Cadastro</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">  
                                        <div class="col-md-4">
                                            <label for="" class="control-label">Há alguma pendência no cliente ?</label>
                                            <select id="sel1" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                            </select>
                                        </div>
                                        <div class="col-md-4">
                                            <label for="" class="control-label">Os documentos do cliente esta conferido ?</label>
                                            <select id="sel1" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                            </select>
                                        </div>
                                        <div class="col-md-4">
                                            <label for="" class="control-label">O cliente esta Apto a participar do leilão ?</label>
                                            <select id="sel1" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                            </select>
                                        </div>

                                        <div class="col-md-4 m-t-md">
                                            <div class="checkbox">
                                                <label class="i-checks">
                                                    <input id="" type="checkbox" value=""><i></i>
                                                    <label for="" class="control-label">Leilões de Veículos</label>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 m-t-md">
                                            <div class="checkbox">
                                                <label class="i-checks">
                                                    <input id="" type="checkbox" value=""><i></i>
                                                    <label for="" class="control-label">Leilões de Imóveis</label>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4 m-t-md">
                                            <div class="checkbox">
                                                <label class="i-checks">
                                                    <input id="" type="checkbox" value=""><i></i>
                                                    <label for="" class="control-label">Leilões de Materiais</label>
                                                </label>
                                            </div>
                                        </div>  
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="panel-body">
                        <div class="panel-heading font-bold">Observações do cadastro</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                               <form class="control-label">
                                    <label for="" class="control-label">Observação</label>
                                    <textarea id="" class="form-control" placeholder="" rows="5" style="resize: none;"></textarea>
                               </form>
                            </div>
                        </div>
                    </div> 
                    <div class="wrapper-md">
                        <button class="btn m-b-xs w-xs btn-info m-r-xs">Salvar</button>
                        <button class="btn m-b-xs w-xs btn-danger m-r-xs">Negativar</button>
                        <button class="btn m-b-xs w-xs btn-default">Cancelar</button>
                    </div>
                </div>
            </div>
        </div><!-- Etapa Arrematantes -->

        <div class="etapa-comitente" style="display: none;">
            <div class="wrapper-md">
                <div class="panel panel-default">
                    <div class="panel-heading font-bold">Editar Comitente</div>
                    <div class="panel-body">
                        <div class="panel-heading font-bold">Dados Comitente</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">  
                                        <div class="col-md-6">
                                            <label for="" class="control-label">Nome</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Tipo de Pessoa</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Tipo de Comitente</label>
                                            <select id="" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                            </select>
                                        </div>

                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Endereço</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Bairro</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Cidade</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Estado</label>
                                            <select id="" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>1</option>
                                                <option>2</option>
                                                <option>3</option>
                                                <option>4</option>
                                            </select>
                                        </div>

                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Cep</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">CNPJ</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Inscrição Estadual</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Código ( Sistema RM )</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Telefone Comercial</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Telefone Fax</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-6 m-t-md">
                                            <label for="" class="control-label">Nome Fantasia</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-6 m-t-md">
                                            <label for="" class="control-label">Qual o prazo para entrega dos documentos ?</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>  
                                        <div class="col-md-3 m-t-lg">
                                            <div class="checkbox">
                                                <label class="i-checks">
                                                    <input id="" type="checkbox" value=""><i></i>
                                                    <label for="" class="control-label">Logo do comitente ?</label>
                                                </label>
                                            </div>
                                        </div> 
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Logo do Comitente</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div> 

                                        <div class="col-md-12 m-t-md">
                                            <label for="" class="control-label">Condições do Comitente para Veículos</label>
                                            <textarea class="form-control" style="resize: none;" rows="5"></textarea>
                                        </div> 
                                        <div class="col-md-12 m-t-md">
                                            <label for="" class="control-label">Condições do Comitente para Materiais</label>
                                            <textarea class="form-control" style="resize: none;" rows="5"></textarea>
                                        </div> 
                                        <div class="col-md-12 m-t-md">
                                            <label for="" class="control-label">Observação</label>
                                            <textarea class="form-control" style="resize: none;" rows="5"></textarea>
                                        </div>                                      
                                    </div>
                                </form>
                            </div>
                            <div class="wrapper-md">
                                <button class="btn m-b-xs w-xs btn-info m-r-xs">Salvar</button>
                                <button class="btn m-b-xs w-xs btn-default">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- Etapa Comitente -->

        <div class="etapa-leilao" style="display: none">
            <div class="wrapper-md">
                <div class="panel panel-default">
                    <div class="panel-heading font-bold">Editar Leilão</div>
                    <div class="panel-body">
                        <div class="panel-heading font-bold">Dados Leilão</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Lote</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-6">
                                            <label for="" class="control-label">Nome</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">
                                            <label for="" class="control-label">Publicar</label>
                                            <select id="" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>Sim</option>
                                                <option>Não</option>
                                            </select>
                                        </div>

                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Data de Abertura</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Horário de Abertura</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Data de Fechamento</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Horário de Fechamento</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Tempo do Pregão</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Logo Agenda</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Local do Leilão</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Leiloeiro</label>
                                            <select id="" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>Sim</option>
                                                <option>Não</option>
                                            </select>
                                        </div>

                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Classificação</label>
                                            <select id="" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>Sim</option>
                                                <option>Não</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Status do Leilão</label>
                                            <select id="" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>Sim</option>
                                                <option>Não</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Leilões Instânciao</label>
                                            <select id="" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>Sim</option>
                                                <option>Não</option>
                                            </select>
                                        </div>
                                        <div class="col-md-3 m-t-md">
                                            <label for="" class="control-label">Loteado</label>
                                            <select id="" class="form-control">
                                                <option selected="selected">Selecione</option>
                                                <option>Sim</option>
                                                <option>Não</option>
                                            </select>
                                        </div>

                                        <div class="col-md-3 m-t-md m-b-lg">
                                            <label for="" class="control-label">Leilão Interno</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-lg m-b-lg">
                                            <div class="checkbox">
                                                <label class="i-checks i-checks-sm">
                                                    <input type="checkbox"><i></i><label for="" class="control-label">Leilão Judicial</label>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-3 m-t-lg m-b-lg">        
                                            <div class="checkbox">
                                                <label class="i-checks i-checks-sm">
                                                    <input type="checkbox"><i></i><label for="" class="control-label">Auto Fechamento</label>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-3 m-t-lg m-b-lg">
                                            <div class="checkbox">
                                                <label class="i-checks i-checks-sm">
                                                    <input type="checkbox"><i></i><label for="" class="control-label">Taxa de ISS e ICMS ?</label>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <hr>
                                        </div>
                        
                                        <div class="col-md-3">                                       
                                            <label for="" class="control-label">Taxa Icms</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">                                       
                                            <label for="" class="control-label">Taxa Iss</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">                                       
                                            <label for="" class="control-label">Cod. Interno (RML)</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2 m-t-xs">                                       
                                            <div class="checkbox">
                                                <label class="i-checks i-checks-sm">
                                                    <input type="checkbox"><i></i><label for="" class="control-label">Comissão</label>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-1">                                       
                                            <label for="" class="control-label">Comissão</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-12 m-t-md">                                       
                                            <label for="" class="control-label">Resumo Leilão</label>
                                            <textarea id="" type="" class="form-control" rows="5" placeholder="" style="resize: none;">
                                            </textarea>
                                        </div>
                                        <div class="col-md-12 m-t-md">                                       
                                            <label for="" class="control-label">Informação de Visitação</label>
                                            <textarea id="" type="" class="form-control" rows="5" placeholder="" style="resize: none;">
                                            </textarea>
                                        </div>
                                        <div class="col-md-12 m-t-md">                                       
                                            <label for="" class="control-label">Informação de Retirada</label>
                                            <textarea id="" type="" class="form-control" rows="5" placeholder="" style="resize: none;">
                                            </textarea>
                                        </div>
                                        <div class="col-md-12 m-t-md">                                       
                                            <label for="" class="control-label">Observação</label>
                                            <textarea id="" type="" class="form-control" rows="5" placeholder="" style="resize: none;">
                                            </textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="wrapper-md">
                                <button class="btn m-b-xs w-xs btn-info m-r-xs">Salvar</button>
                                <button class="btn m-b-xs w-xs btn-default">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- Etapa Leilao -->

        <div class="etapa-contato" style="display: none">
            <div class="wrapper-md">
                <div class="panel panel-default">
                    <div class="panel-heading font-bold">Editar Contatos</div>
                    <div class="panel-body">
                        <div class="panel-heading font-bold">Dados de Contatos</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">
                                        <div class="col-md-12">                                       
                                            <label for="" class="control-label">Nome</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-4 m-t-md">                                       
                                            <label for="" class="control-label">Email</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-4 m-t-md">                                       
                                            <label for="" class="control-label">Telefone</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-4 m-t-lg">                                       
                                            <div class="checkbox">
                                                <label class="i-checks i-checks-sm">
                                                    <input type="checkbox"><i></i><label for="" class="control-label">Auto Fechamento</label>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="col-md-12 m-t-md">                                       
                                            <label for="" class="control-label">Mensagem</label>
                                            <textarea id="" type="" class="form-control" rows="5" placeholder="" style="resize: none;">
                                            </textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="wrapper-md">
                                <button class="btn m-b-xs w-xs btn-info m-r-xs">Salvar</button>
                                <button class="btn m-b-xs w-md btn-info m-r-xs">Responder Mensagem</button>
                                <button class="btn m-b-xs w-xs btn-default">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- Etapa Contato -->

        <div class="etapa-leiloeiro" style="display: none">
            <div class="wrapper-md">
                <div class="panel panel-default">
                    <div class="panel-heading font-bold">Editar Leiloeiro</div>
                    <div class="panel-body">
                        <div class="panel-heading font-bold">Dados do Leiloeiro</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">
                                        <div class="col-md-9">                                       
                                            <label for="" class="control-label">Nome</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3">                                       
                                            <label for="" class="control-label">Telefone</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Bairro</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Cidade</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Endereço</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-1 m-t-md">                                       
                                            <label for="" class="control-label">Número</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2 m-t-md">                                       
                                            <label for="" class="control-label">Complemento</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Cep</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Fax</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="wrapper-md">
                                <button class="btn m-b-xs w-xs btn-info m-r-xs">Salvar</button>
                                <button class="btn m-b-xs w-xs btn-default">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- Etapa Leiloeiro -->

        <div class="etapa-banner">
            <div class="wrapper-md">
                <div class="panel panel-default" style="display: none;">
                    <div class="panel-heading font-bold">Editar Banner</div>
                    <div class="panel-body">
                        <div class="panel-heading font-bold">Dados do Banner</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">
                                        <div class="col-md-10 m-t-md">                                       
                                            <label for="" class="control-label">Nome</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2 m-t-md">                                       
                                            <label for="" class="control-label">Ordem</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-4 m-t-md">                                       
                                            <label for="" class="control-label">Este banner contém vídeo ?</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Data Exibição</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Horário Exibição</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2 m-t-md">                                       
                                            <label for="" class="control-label">SituacaoId</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="wrapper-md">
                                <button class="btn m-b-xs w-xs btn-info m-r-xs">Salvar</button>
                                <button class="btn m-b-xs w-xs btn-default">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- Etapa Banner -->

        <div class="etapa-documento">
            <div class="wrapper-md">
                <div class="panel panel-default">
                    <div class="panel-heading font-bold">Editar Documentos</div>
                    <div class="panel-body">
                        <div class="panel-heading font-bold">Dados de Documentos</div>
                        <div style="border: 1px solid #dee5e7">
                            <div class="wrapper-md">
                                <form class="bs-example form-horizontal">
                                    <div class="form-group">
                                        <div class="col-md-10">                                       
                                            <label for="" class="control-label">Nome do Arrematante</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2 m-t-md">                                       
                                            <div class="checkbox">
                                                <label class="i-checks i-checks-sm">
                                                    <input type="checkbox"><i></i><label for="" class="control-label">Termo</label>
                                                </label>
                                            </div>
                                        </div>

                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Data do Leilão</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-3 m-t-md">                                       
                                            <label for="" class="control-label">Placa</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2 m-t-md">                                       
                                            <label for="" class="control-label">Cpf</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2 m-t-md">                                       
                                            <label for="" class="control-label">Lote Número</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>
                                        <div class="col-md-2 m-t-md">                                       
                                            <label for="" class="control-label">Tipo</label>
                                            <input id="" type="" class="form-control" placeholder="">
                                        </div>

                                        <div class="col-md-12 m-t-md">                                       
                                            <label for="" class="control-label">Observação</label>
                                            <textarea id="" type="" class="form-control" rows="5" placeholder="" style="resize: none;">
                                            </textarea>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="wrapper-md">
                                <button class="btn m-b-xs w-xs btn-info m-r-xs">Salvar</button>
                                <button class="btn m-b-xs w-xs btn-default">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- Etapa Documento -->
    </div>
</template>



// WEBPACK FOOTER //
// Editar.vue?644e81b8